module.exports = __webpack_public_path__ + "static/carousel-1-f797f669101f52499c765246752005db.jpg";